import { render, staticRenderFns } from "./CatalogCategories.vue?vue&type=template&id=bc1d0ee2&scoped=true"
import script from "./CatalogCategories.vue?vue&type=script&lang=js"
export * from "./CatalogCategories.vue?vue&type=script&lang=js"
import style0 from "./CatalogCategories.vue?vue&type=style&index=0&id=bc1d0ee2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc1d0ee2",
  null
  
)

export default component.exports